import { graphql } from "~/gql";

export const UPDATE_TASK = graphql(/* GraphQL */ `
  mutation updateTask($data: TaskUpdateInput!, $taskId: Float!) {
    updateTask(data: $data, taskId: $taskId) {
      id
      title
      html
      order
      markedComplete
      startDate
      deadlineDate
    }
  }
`);

export const UPDATE_TASKS = graphql(/* GraphQL */ `
  mutation updateTasks($data: [UpdateTaskInput!]!) {
    updateTasks(data: $data) {
      id
      title
      html
      order
      markedComplete
      startDate
      deadlineDate
    }
  }
`);
